export const MixpanelEvents = {
  PAYWALL_VIEWED: "Paywall Viewed",
  PURCHASE_STARTED: "Purchase Started",
  PURCHASE_RESULT: "Purchase Result",
  SUBSCRIPTION_VERIFICATION_RESULT: "Subscription Verification Result",
  SUBSCRIPTION_ACCESS_UNLOCKED: "Subscription Access Unlocked",
  ACCOUNT_CREATED: "Account Created",
  ONBOARDING_STARTED: "Onboarding Started",
  ONBOARDING_STEP_VIEWED: "Onboarding Step Viewed",
  ONBOARDING_STEP_SUBMITTED: "Onboarding Step Submitted",
  ONBOARDING_HELP_WITH_SELECTED: "Onboarding Help With Selected",
  ONBOARDING_COMPLETED: "Onboarding Completed",
  ONBOARDING_WELCOME_STARTED: "Onboarding Welcome Started",
  MEAL_TAB_NAVIGATED: "Meal Tab Navigated",
  AI_CHAT_OPENED: "AI Chat Opened",
  AI_CHAT_SUGGESTION_TAPPED: "AI Chat Suggestion Tapped",
  AI_CHAT_MESSAGE_SENT: "AI Chat Message Sent",
  AI_CHAT_FIRST_TOKEN: "AI Chat First Token",
  AI_CHAT_RESPONSE_RECEIVED: "AI Chat Response Received",
  AI_CHAT_RESPONSE_FAILED: "AI Chat Response Failed",
  AI_CHAT_ATTACHMENT_ADDED: "AI Chat Attachment Added",
  AI_CHAT_ATTACHMENT_REMOVED: "AI Chat Attachment Removed",
  AI_CHAT_ATTACHMENT_RESTORED: "AI Chat Attachment Restored",
  AI_CHAT_NEW_CHAT_STARTED: "AI Chat New Chat Started",
  AI_CHAT_INTERRUPT_ANSWERED: "AI Chat Interrupt Answered",
  AI_CHAT_VOICE_RECORD_STARTED: "AI Chat Voice Record Started",
  AI_CHAT_VOICE_RECORD_CANCELLED: "AI Chat Voice Record Cancelled",
  AI_CHAT_VOICE_RECORD_CONFIRMED: "AI Chat Voice Record Confirmed",
  AI_CHAT_VOICE_TRANSCRIBE_SUCCEEDED: "AI Chat Voice Transcribe Succeeded",
  AI_CHAT_VOICE_TRANSCRIBE_FAILED: "AI Chat Voice Transcribe Failed",
  AI_CHAT_VOICE_PERMISSION_DENIED: "AI Chat Voice Permission Denied",
  MY_PLAN_MEAL_COACH_TAPPED: "My Plan Meal Coach Tapped",
  MY_PLAN_TAB_TAPPED: "My Plan Tab Tapped",
  MY_PLAN_VIEWED: "My Plan Viewed",
  MY_PLAN_ENGAGEMENT_ENDED: "My Plan Engagement Ended",
  MY_PLAN_INTERACTION: "My Plan Interaction",
  OVERVIEW_ADJUST_PLAN_TAPPED: "Overview Adjust Plan Tapped",
  OVERVIEW_WEEKLY_BALANCE_EXPLAINER_TAPPED: "Overview Weekly Balance Explainer Tapped",
  AI_CHAT_RESUMED_AFTER_RESTART: "AI Chat Resumed After Restart",
} as const;
